<div class="displayLibsCenter" fxFlex="33"
     fxLayout="column" fxLayoutAlign="center center">
  <app-confirm-email [returnLink]="'/register'"
                     [useLethaSpec]="false"
                     [displayImage]="true" [successLink]="'/login'"
                     [logoImage]="'../../../assets/logos/saCentre.png'"
                     [apiEndpoint]="endPoint">
  </app-confirm-email>

</div>
